var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityOnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.222,
    height: 15.673,
    viewBox: "0 0 25.222 15.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9801",
    "data-name": "Group 9801",
    transform: "translate(-1132 -615.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-svgrepo-com_1_",
    "data-name": "eye-svgrepo-com (1)",
    transform: "translate(1132 499.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9799",
    "data-name": "Group 9799",
    transform: "translate(0 115.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80171",
    "data-name": "Path 80171",
    d: "M25.124,124.078a.815.815,0,0,0,0-.777A14.235,14.235,0,0,0,.1,123.3a.815.815,0,0,0,0,.777,14.235,14.235,0,0,0,25.025,0ZM12.612,129.7a6.011,6.011,0,1,1,6.011-6.011A6.011,6.011,0,0,1,12.612,129.7Z",
    transform: "translate(0 -115.853)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80172",
    "data-name": "Path 80172",
    d: "M234.732,231.67a3.071,3.071,0,0,0-.734.089A1.589,1.589,0,0,1,231.758,234a3.064,3.064,0,1,0,2.975-2.33Z",
    transform: "translate(-222.121 -226.897)",
    fill: "#c6c6c6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOnIcon);
export default __webpack_public_path__ + "static/media/visibility-on-icon.aab1a851b39941b9d835cd2e0b1c816a.svg";
export { ForwardRef as ReactComponent };